import { combineReducers } from 'redux';
import activation from './activation';

export default combineReducers({
  activation
});
